"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUserHelper = exports.getComments = exports.deleteReaction = exports.comment = exports.like = exports.createSocialPost = exports.getSocialFeed = void 0;
var axios_1 = __importDefault(require("axios"));
var helperFunctions_1 = require("../../util/helperFunctions");
var getSocialFeed = function (_a) {
    var userId = _a.userId, latestId = _a.latestId, more = _a.more;
    return (0, helperFunctions_1.getGetstreamToken)(userId)
        .then(function (getstreamToken) {
        var user = (0, helperFunctions_1.getTimeline)((0, helperFunctions_1.streamConnect)(getstreamToken), userId);
        var query = {
            limit: 10,
            enrich: true,
            reactions: {
                recent: false,
                counts: true,
                own: true
            }
        };
        //gte - greater or equal - posts BEFORE given  (created later || more recent)
        //lt - less - posts AFTER (created earlier || created much time ago)
        if (latestId) {
            if (more)
                query.id_lt = latestId;
            else
                query.id_gte = latestId;
        }
        return user.get(query);
    });
};
exports.getSocialFeed = getSocialFeed;
var createSocialPost = function (payload) {
    return axios_1.default.post("".concat(process.env.REACT_APP_BACKEND_DOMAIN, "/api/v2/post/add"), payload);
};
exports.createSocialPost = createSocialPost;
var like = function (payload) {
    return axios_1.default.post("".concat(process.env.REACT_APP_BACKEND_DOMAIN, "/api/v2/reaction/like"), payload);
};
exports.like = like;
var comment = function (payload) {
    return axios_1.default.post("".concat(process.env.REACT_APP_BACKEND_DOMAIN, "/api/v2/reaction/comment"), payload);
};
exports.comment = comment;
var deleteReaction = function (payload) {
    return axios_1.default.delete("".concat(process.env.REACT_APP_BACKEND_DOMAIN, "/api/v2/reaction"), {
        params: payload
    });
};
exports.deleteReaction = deleteReaction;
var getComments = function (_a) {
    var userId = _a.userId, activityId = _a.activityId;
    return (0, helperFunctions_1.getGetstreamToken)(userId)
        .then(function (getstreamToken) {
        var client = (0, helperFunctions_1.streamConnect)(getstreamToken);
        return client.reactions.filter({
            activity_id: activityId,
            kind: 'comment'
        });
    });
};
exports.getComments = getComments;
function getUserHelper() {
    return axios_1.default.get("https://".concat(process.env.REACT_APP_TRYBE_WP, "/wp-json/trybe/v1/user/profile/note"));
}
exports.getUserHelper = getUserHelper;
